import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'dibs-react-intl';

function CheckoutFormatAmount({ currency, financialAmount }) {
    const convertedAmountList = get(financialAmount, 'convertedAmountList') || [];
    const amountObj = convertedAmountList.find(a => a.currency === currency) || {};
    const amount = amountObj.amount || 0;
    return <FormattedNumber value={amount} style="currency" currency={currency} />;
}

CheckoutFormatAmount.propTypes = {
    currency: PropTypes.string.isRequired,
    financialAmount: PropTypes.object, // assign to null when amount is zero
};

export default createFragmentContainer(CheckoutFormatAmount, {
    financialAmount: graphql`
        fragment CheckoutFormatAmount_financialAmount on FinancialAmount {
            amount
            convertedAmountList {
                amount
                currency
            }
        }
    `,
});
